var $37cff576474bc8d4$exports = {};
$37cff576474bc8d4$exports = {
  "alpha": "Alpha",
  "black": "\u9ED1",
  "blue": "\u85CD\u8272",
  "blue purple": "\u85CD\u7D2B",
  "brightness": "\u4EAE\u5EA6",
  "brown": "\u68D5",
  "brown yellow": "\u68D5\u9EC3",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "\u9752",
  "cyan blue": "\u9752\u85CD",
  "dark": "\u6697",
  "gray": "\u7070",
  "grayish": "\u504F\u7070",
  "green": "\u7DA0\u8272",
  "green cyan": "\u9752\u7DA0",
  "hue": "\u8272\u76F8",
  "light": "\u6DFA",
  "lightness": "\u660E\u4EAE",
  "magenta": "\u6D0B\u7D05",
  "magenta pink": "\u6DFA\u6D0B\u7D05",
  "orange": "\u6A59",
  "orange yellow": "\u6A59\u9EC3",
  "pale": "\u6DE1",
  "pink": "\u7C89\u7D05",
  "pink red": "\u7C89\u7D05",
  "purple": "\u7D2B",
  "purple magenta": "\u7D2B\u6D0B\u7D05",
  "red": "\u7D05\u8272",
  "red orange": "\u6A59\u7D05",
  "saturation": "\u98FD\u548C\u5EA6",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " \u900F\u660E");
  },
  "very dark": "\u5F88\u6697",
  "very light": "\u5F88\u6DFA",
  "vibrant": "\u9BAE\u8C54",
  "white": "\u767D",
  "yellow": "\u9EC3",
  "yellow green": "\u9EC3\u7DA0"
};
export { $37cff576474bc8d4$exports as default };